<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              <router-link :to="{ name: 'almacen' }">{{
                $t("almacen")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("historial") }} {{ nombreProducto }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <h2 class="tituloNumier">
          <i class="fa fa-building"></i> {{ nombreNegocio }}
        </h2>
        <hr />
      </div>

      <div class="col-md-2">
        <h3>{{ nombreProducto }}</h3>
      </div>

      <div class="col-md-4" v-if="filtradoPorInventarios">
        <label
          ><strong>{{ $t("tipo") }}</strong></label
        >
        <div class="form-group">
          <el-radio
            @change="filtroTipoInventarios"
            v-model="procedencia"
            label="T"
          >
            {{ $t("todos") }}
          </el-radio>
          <el-radio
            @change="filtroTipoInventarios"
            v-model="procedencia"
            label="I"
          >
            {{ $t("inventarios") }}
          </el-radio>
          <el-radio
            @change="filtroTipoInventarios"
            v-model="procedencia"
            label="S"
          >
            {{ $t("salidas") }}
          </el-radio>
          <el-radio
            @change="filtroTipoInventarios"
            v-model="procedencia"
            label="E"
          >
            {{ $t("entradas") }}
          </el-radio>
        </div>
      </div>

      <div class="col-md-4" v-else>
        <label
          ><strong>{{ $t("tipo") }}</strong></label
        >
        <div class="form-group">
          <el-radio @change="filtroTipo" v-model="procedencia" label="T">
            {{ $t("todos") }}
          </el-radio>
          <el-radio @change="filtroTipo" v-model="procedencia" label="I">
            {{ $t("inventarios") }}
          </el-radio>
          <el-radio @change="filtroTipo" v-model="procedencia" label="S">
            {{ $t("salidas") }}
          </el-radio>
          <el-radio @change="filtroTipo" v-model="procedencia" label="E">
            {{ $t("entradas") }}
          </el-radio>
        </div>
      </div>

      <!--Buscador por fechas-->

      <div class="col-md-2">
        <div class="form-group">
          <label>{{ $t("fechaInicio") }}</label>
          <datetime
            value-zone="Europe/Madrid"
            :auto="true"
            class="theme-numier"
            format="dd-MM-yyyy"
            :title="$t('fechaInicio')"
            :phrases="{ ok: 'Aceptar', cancel: 'Salir' }"
            input-class="form-control"
            v-model="datefrom"
          ></datetime>
        </div>
      </div>

      <div class="col-md-2">
        <div class="form-group">
          <label>{{ $t("fechaFin") }}</label>
          <datetime
            value-zone="Europe/Madrid"
            :auto="true"
            class="theme-numier"
            :title="$t('fechaFin')"
            format="dd-MM-yyyy"
            :phrases="{ ok: 'Aceptar', cancel: 'Salir' }"
            input-class="form-control"
            v-model="dateto"
          ></datetime>
        </div>
      </div>

      <div class="col-md-12">
        <label>&nbsp;</label>
        <div class="form-group">
          <div class="btn-group d-flex flex-wrap" role="group">
            <!-- Botón Consultar -->
            <button
              @click="getDetallesSubproduct(1)"
              type="button"
              class="btn btn-primary d-flex align-items-center justify-content-center m-1"
            >
              <i class="fa fa-search mr-2"></i> {{ $t("consultar") }}
            </button>

            <!-- Botón Último Inventario -->
            <button
              @click="getDetallesSubproduct(0)"
              type="button"
              class="btn btn-warning d-flex align-items-center justify-content-center m-1"
            >
              <i class="fa fa-history mr-2"></i> {{ $t("ultimoInventario") }}
            </button>

            <!-- Botón Exportar Excel -->
            <a :href="urlExportExcelMovimientosAlmacen">
              <button
                type="button"
                class="btn btn-success d-flex align-items-center justify-content-center m-1"
              >
                <i class="fa fa-file-excel mr-2"></i> {{ $t("exportarExcel") }}
              </button>
            </a>
          </div>
        </div>
      </div>


      <div class="col-md-12" v-if="listMovimientosFiltro.length === 0">
        <div class="alert alert-danger" role="alert">
          {{ $t("noHayMovimientoEnEstaMateriaPrima") }}
        </div>
      </div>

      <!--   :class="{'is-valid': agencia.name.length >0 && agencia.name.length <= maxNameAgencia,
                                       'is-invalid': agencia.name.length > maxNameAgencia}"-->

      <template v-else>
        <div
          class="col-md-4"
          v-if="listInventarios.length === 2 && !filtradoPorInventarios"
        >
          <button
            type="button"
            @click="filtrarInventarios()"
            class="btn btn-success"
          >
            <i class="fas fa-filter"></i> {{ $t("filtrarEntreInventarios") }}
          </button>
        </div>
        <div class="col-md-2">
          <button
            v-if="listInventarios.length === 2 && filtradoPorInventarios"
            type="button"
            @click="getDetallesSubproduct(+ buscarPorHoras), (filtradoPorInventarios = false)"
            class="btn btn-danger"
          >
            <i class="fas fa-undo"></i> {{ $t("volver") }}
          </button>
        </div>
        <div class="col-md-10" style="text-align: right" v-if="!buscarPorHoras">
          <span class="col-md-2"
            ><strong class="text-primary">
              <span v-if="!filtradoPorInventarios"
                >{{ $t("ultInventario")}} :</span
              ><span v-else>{{ $t("primerInventario")}} :</span
              > {{ calcularUltimoInventario }}
            </strong></span
          >

          <span class="col-md-2"
            ><strong class="text-danger"
              >{{ $t("salidas") }}: {{ calcularSalida }}
            </strong></span
          >
          <span class="col-md-2"
            ><strong class="text-success"
              >{{ $t("entradas") }}: {{ calcularEntrada }}</strong
            ></span
          >
          <!--<span class="col-md-2"><strong class="text-warning">Ventas: {{calcularVentas}} </strong></span>-->

          <span class="col-md-2"
            ><strong> {{ $t("total") }}: {{ calcularTotal }}</strong></span
          >

          <!--<template v-if="filtradoPorInventarios"><br>
                         </template>-->
        </div>

        <span class="col-md-12"
          ><strong
            ><small
              ><i class="fas fa-info-circle"></i
              >{{
                $t("marcaDosInventariosParaVerLosDetallesEntreEllos")
              }}</small
            ></strong
          ></span
        >
        <!--<div v-if="filtradoPorInventarios" class="col-md-12" style="text-align: right">
                    <span class="col-md-2 text-primary"><strong> Ultimo Inventario: {{listMovimientosFiltro[0].unidadesRelleno}}<template
                            v-if="listMovimientosFiltro[0].escandallo>1">/{{listMovimientosFiltro[0].partesRelleno}}</template></strong></span>
                    <span class="col-md-2 text-primary"><strong> Diferencia:  {{listMovimientosFiltro[0].unidades}}<template
                            v-if="listMovimientosFiltro[0].escandallo>1">/{{listMovimientosFiltro[0].partes}}</template></strong></span>
                </div>-->

        <div class="col-md-12" v-for="(m, index) in listMovimientosFiltro">
          <!--INVENTARIOS-->
          <div
            @click="cambioColor(m, index)"
            v-if="m.tipo === 'I'"
            class="card"
            v-bind:style="[
              !m.editable
                ? { backgroundColor: 'white' }
                : { backgroundColor: '#CBFBC7' },
            ]"
            style="cursor: pointer"
          >
            <div class="row">
              <div class="col-1 text-center">
                <i
                  class="fas fa-arrow-left text-success"
                  v-if="m.tipo === 'E'"
                ></i>
                <i
                  class="fas fa-arrow-right text-danger"
                  v-else-if="m.tipo === 'S'"
                ></i>
                <i class="fas fa-arrows-alt-h text-info" v-else></i>
              </div>
              <div class="col-md-11">
                <div class="row">
                  <div class="col-md-4">
                    <strong>{{ $t("dia") }}:</strong>
                    {{ m.date | parseDateMin }}
                  </div>
                  <div class="col-md-4">
                    <strong>{{ $t("referencia") }}:</strong> {{ m.reference }}
                  </div>
                  <div class="col-md-4 text-right">


                      <!-- <strong>Diferencia:</strong> {{ m.unidades }}     ESTO ESTABA ANTES  -->
                      <template v-if="m.partesRelleno >= diferenciaPartRecuento">
                        <strong>Diferencia:</strong> {{ m.unidadesRelleno - diferenciaUndRecuento}}
                      </template>
                      <template v-else>
                        <strong>Diferencia:</strong> {{ (m.unidadesRelleno - 1) - diferenciaUndRecuento}}
                      </template>
                      
                      <!-- tendria que ser el recuento - total ((1º Inventario + entradas) - salidas) -->
                      <template v-if="m.escandallo > 1">
                        <span v-if="m.partesRelleno >= diferenciaPartRecuento">/ {{ m.partesRelleno - diferenciaPartRecuento}}</span>

                        <span v-else>/ {{ (m.partesRelleno + m.escandallo) - diferenciaPartRecuento}}</span>
                      </template>
                      <!-- <span v-if="m.escandallo > 1">/ {{ m.partes }}</span> -->


                    <template v-if="m.tipo === 'I'">
                      <br />
                      <small
                        ><strong>{{ $t("recuento") }}:</strong>
                        {{ m.unidadesRelleno }}
                        <span v-if="m.escandallo > 1"
                          >/ {{ m.partesRelleno }}</span
                        >
                      </small>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--SALIDAS Y ENTRADAS-->
          <div v-else class="card">
            <div class="row">
              <div class="col-1 text-center">
                <i v-if="m.noCuentaStock" v-tooltip.top-center="
                    'Este movimiento de almacén fue incluido en un gasto que al ser verificado no se contabilizó.'" class='fa fa-warning' style='color: orangered; margin-right: 8%;'></i>
                <i
                  class="fas fa-arrow-left text-success"
                  v-if="m.tipo === 'E'"
                ></i>
                <i
                  class="fas fa-arrow-right text-danger"
                  v-else-if="m.tipo === 'S'"
                ></i>
                <i class="fas fa-arrows-alt-h text-info" v-else></i>
              </div>
              <div class="col-md-11">
                <div class="row">
                  <div class="col-md-4">
                    <strong>{{ $t("dia") }}:</strong>
                    {{ m.date | parseDateMin }}
                  </div>
                  <div class="col-md-4">
                    <strong>{{ $t("referencia") }}:</strong> {{ m.reference }}
                  </div>
                  <div class="col-md-4 text-right">
                    <strong>{{ $t("uds") }}:</strong> {{ m.unidades }}
                    <span v-if="m.escandallo > 1">/ {{ m.partes }}</span>

                    <template v-if="m.tipo === 'I'">
                      <br />
                      <small
                        ><strong>{{ $t("recuento") }}:</strong>
                        {{ m.unidadesRelleno }}
                        <span v-if="m.escandallo > 1"
                          >/ {{ m.partesRelleno }}</span
                        >
                      </small>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Radio,
  Button,
  Steps,
  Step,
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

export default {
  name: "DetalleSubproductoAlmacen",

  data() {
    return {
      idSub: this.$route.params.idSub,
      idBusiness: this.$route.params.idBusiness,
      listMovimientos: [],
      listMovimientosFiltro: [],
      listaDetalles: [],
      nombreProducto: "",
      nombreNegocio: "",

      //DETALLE ALMACEN POR FECHA
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      procedencia: "T",
      loading: false,
      buscarPorHoras: false,

      //INVENTARIO
      listInventarios: [],
      filtradoPorInventarios: false,
      listFiltroInventarios: [],
      diferenciaUndRecuento:0,
      diferenciaPartRecuento:0,
    };
  },
  created() {
    this.identificacionNegocio();
    this.getDetallesSubproduct(0);
  },
  computed: {
      urlExportExcelMovimientosAlmacen() {
      const tipo = '0';
      const datefromUnix = moment(this.datefrom).unix();
      const datetoUnix = moment(this.dateto).unix();

      return (
        this.$store.getters.apiUrl +
        "almacen/exportMovimientosAlmacen" +
        "?idBusiness=" + this.idBusiness +
        "&idSubproduct=" + this.idSub +
        "&datefrom=" + datefromUnix +
        "&dateto=" + datetoUnix +
        "&tipo=" + tipo +
        "&jwt=" + this.$store.getters.jwt
      );
    },
    calcularEntrada() {
      let entradaUnidades = 0;
      let entradaPartes = 0;
      if (!this.buscarPorHoras) {
        this.listMovimientosFiltro.forEach(function (x) {
          if (x.tipo === "E") {
            entradaUnidades += x.unidades;
            entradaPartes += x.partes;
          }
        });

        entradaUnidades += this.calcularUnidades(
          entradaPartes,
          this.listMovimientosFiltro[0].escandallo
        );
        entradaPartes = this.calcularPartes(
          entradaPartes,
          this.listMovimientosFiltro[0].escandallo
        );
      }

      if (
        this.listMovimientosFiltro[0].escandallo == 0 ||
        this.listMovimientosFiltro[0].escandallo == 1
      ) {
        return entradaUnidades;
      } else {
        return entradaUnidades + "/" + entradaPartes;
      }
    },
    /* calcularVentas() {

                let ventasUnidades = 0;
                let ventasPartes = 0;

                if (!this.buscarPorHoras) {
                    this.listMovimientosFiltro.forEach(function (x) {

                        if (x.tipo === 'S' && x.reference.indexOf("Cierre:" === 0)) {
                            ventasUnidades += x.unidades;
                            ventasPartes += x.partes;
                        }

                    });

                    ventasUnidades += this.calcularUnidades(ventasPartes, this.listMovimientosFiltro[0].escandallo);
                    ventasPartes = this.calcularPartes(ventasPartes, this.listMovimientosFiltro[0].escandallo)
                }

                if (this.listMovimientosFiltro[0].escandallo == 0 || this.listMovimientosFiltro[0].escandallo == 1) {

                    return ventasUnidades;
                }
                else {
                    return ventasUnidades + '/' + ventasPartes;
                }
            },*/
    calcularSalida() {
      let salidaUnidades = 0;
      let salidaPartes = 0;

      if (!this.buscarPorHoras) {
        this.listMovimientosFiltro.forEach(function (x) {
          if (x.tipo === "S") {
            salidaUnidades += x.unidades;
            salidaPartes += x.partes;
          }
        });

        salidaUnidades += this.calcularUnidades(
          salidaPartes,
          this.listMovimientosFiltro[0].escandallo
        );
        salidaPartes = this.calcularPartes(
          salidaPartes,
          this.listMovimientosFiltro[0].escandallo
        );
      }

      if (
        this.listMovimientosFiltro[0].escandallo == 0 ||
        this.listMovimientosFiltro[0].escandallo == 1
      ) {
        return salidaUnidades;
      } else {
        return salidaUnidades + "/" + salidaPartes;
      }
    },
    calcularUltimoInventario() {
      let totalUnidades = 0;
      let totalPartes = 0;

      if (!this.buscarPorHoras) {
        //Se introduce el inventario

        if (
          this.listMovimientosFiltro[this.listMovimientosFiltro.length - 1]
            .tipo === "I"
        ) {
          totalUnidades = this.listMovimientosFiltro[
            this.listMovimientosFiltro.length - 1
          ].unidadesRelleno;
          totalPartes = this.listMovimientosFiltro[
            this.listMovimientosFiltro.length - 1
          ].partesRelleno;
        }
      }
      if (
        this.listMovimientosFiltro[this.listMovimientosFiltro.length - 1]
          .escandallo == 0 ||
        this.listMovimientosFiltro[this.listMovimientosFiltro.length - 1]
          .escandallo == 1
      ) {
        return totalUnidades;
      } else {
        return totalUnidades + "/" + totalPartes;
      }
    },
    calcularTotal() {
      let totalUnidades = 0;
      let totalPartes = 0;

      let escandallo = this.listMovimientosFiltro[0].escandallo;

      if (!this.buscarPorHoras) {
        //Se introduce el inventario

        if (
          this.listMovimientosFiltro[this.listMovimientosFiltro.length - 1]
            .tipo === "I"
        ) {
          if (
            this.listMovimientosFiltro[0].escandallo == 0 ||
            this.listMovimientosFiltro[0].escandallo == 1
          ) {
            totalUnidades = this.listMovimientosFiltro[
              this.listMovimientosFiltro.length - 1
            ].unidadesRelleno;
          } else {
            totalPartes +=
              this.listMovimientosFiltro[this.listMovimientosFiltro.length - 1]
                .unidadesRelleno *
                escandallo +
              this.listMovimientosFiltro[this.listMovimientosFiltro.length - 1]
                .partesRelleno;
          }
        }

        let vm = this;
        this.listMovimientosFiltro.forEach(function (x) {
          if (x.tipo === "S") {
            if (
              vm.listMovimientosFiltro[0].escandallo == 0 ||
              vm.listMovimientosFiltro[0].escandallo == 1
            ) {
              totalUnidades += x.unidades;
            } else {
              totalPartes += x.unidades * escandallo + x.partes;
            }
          } else if (x.tipo === "E") {
            if (
              vm.listMovimientosFiltro[0].escandallo == 0 ||
              vm.listMovimientosFiltro[0].escandallo == 1
            ) {
              totalUnidades += x.unidades;
            } else {
              totalPartes += x.unidades * escandallo + x.partes;
            }
          }
        });

        if (
          this.listMovimientosFiltro[0].escandallo !== 0 &&
          this.listMovimientosFiltro[0].escandallo !== 1
        ) {
          totalUnidades += this.calcularUnidades(
            totalPartes,
            this.listMovimientosFiltro[0].escandallo
          );

          totalPartes = this.calcularPartes(
            totalPartes,
            this.listMovimientosFiltro[0].escandallo
          );
        }
      }

      if (
        this.listMovimientosFiltro[0].escandallo == 0 ||
        this.listMovimientosFiltro[0].escandallo == 1
      ) {
        
        this.diferenciaUndRecuento = totalUnidades
          return totalUnidades;
      } else {
        this.diferenciaUndRecuento = totalUnidades
        this.diferenciaPartRecuento = totalPartes
        return totalUnidades + "/" + totalPartes;
      }
    },
  },
  watch: {
    listInventarios(val) {
      if(val.length < 2) {
        this.buscarPorHoras = true;

        this.filtradoPorInventarios = false;
        
        this.diferenciaUndRecuento = 0;
        this.diferenciaPartRecuento = 0;
      }
    }
  },
  methods: {
    ordenarIds() {
      function compareId(a, b) {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      }

      return this.listInventarios.sort(compareId);
    },

    ordenarIdsFiltroInventario() {
      function compareIdfilter(a, b) {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      }

      return this.listMovimientosFiltro.sort(compareIdfilter);
    },

    filtrarInventarios() {
      this.ordenarIds();

      let listaFiltro = [];

      for (let i = 0; i < this.listMovimientos.length; i++) {
        if (
          this.listMovimientos[i].date >= this.listInventarios[0].date &&
          this.listMovimientos[i].date <= this.listInventarios[1].date
        ) {
          listaFiltro.push(this.listMovimientos[i]);
        }
      }

      this.buscarPorHoras = false;
      this.listMovimientosFiltro = listaFiltro;
      // JOSEMI: He comentado la linea de abajo porque creo que no tiene sentido y esta haciendo mas confusa la logica de la pagina
      // this.listFiltroInventarios = listaFiltro;

      this.filtradoPorInventarios = true;
    },

    cambioColor(m, index) {
      if (!m.editable) {
        if (this.listInventarios.length === 2) {
          swal({
            title: this.$t("atencion"),
            text: this.$t("soloPuedeComprobar2InventariosAlMismoTiempo"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.listInventarios.push(m);
          m.editable = true;
        }
      } else {
        m.editable = false;

        for (let i = 0; i < this.listInventarios.length; i++) {
          if (this.listInventarios[i].id === m.id) {
            this.listInventarios.splice(i, 1);
          }
        }
      }
    },

    filtroTipo() {
      this.listMovimientosFiltro = [];
      let vm = this;
      this.listMovimientos.forEach(function (x) {
        switch (vm.procedencia) {
          case "T":
            vm.listMovimientosFiltro = vm.listMovimientos;

            break;

          case "I":
            if (x.tipo === "I") {
              vm.listMovimientosFiltro.push(x);
            }

            break;

          case "E":
            if (x.tipo === "E") {
              vm.listMovimientosFiltro.push(x);
            }

            break;

          case "S":
            if (x.tipo === "S") {
              vm.listMovimientosFiltro.push(x);
            }
        }
      });
    },
    filtroTipoInventarios() {
      this.listMovimientosFiltro = [];
      let vm = this;
      this.listFiltroInventarios.forEach(function (x) {
        switch (vm.procedencia) {
          case "T":
            vm.listMovimientosFiltro = vm.listFiltroInventarios;

            break;

          case "I":
            if (x.tipo === "I") {
              vm.listMovimientosFiltro.push(x);
            }

            break;

          case "E":
            if (x.tipo === "E") {
              vm.listMovimientosFiltro.push(x);
            }

            break;

          case "S":
            if (x.tipo === "S") {
              vm.listMovimientosFiltro.push(x);
            }
        }
      });
    },

    identificacionNegocio() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/identifyBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.nombreNegocio = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    getDetallesSubproduct(type) {
      this.loading = true;
      this.listInventarios = [];
      this.filtradoPorInventarios = false;

      if (type === 0) {
        this.buscarPorHoras = false;
      } else {
        this.buscarPorHoras = true;
      }

      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          var config = {
            params: {
              idBusiness: this.idBusiness,
              jwt: this.$store.getters.jwt,
              tipo: type,
              datefrom: moment(this.datefrom).startOf("day").unix(),
              dateto: moment(this.dateto).endOf("day").unix(),
              idSub: this.idSub,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          this.$store.dispatch("setIdBusiness", this.idBusiness);
          let vm = this;
          this.axios
            .get(
              this.$store.getters.apiUrl + "almacen/getMovimientosSubproducts",
              config
            )
            .then(function (response) {
              if (response.data.response) {
                vm.loading = false;

                vm.listMovimientos = response.data.result.cabecera;
                vm.listMovimientosFiltro = response.data.result.cabecera;
                vm.nombreProducto =
                  response.data.result.cabecera[0].nombreProducto;
                vm.listaDetalles = response.data.result.detalles;

                vm.filtroTipo();
              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
            });
        }
      }
    },

    calcularUnidades(partes, escandallo) {
      if (escandallo === 1) {
        return partes;
      } else if (escandallo === 0) {
        return 0;
      } else {
        return (partes - (partes % escandallo)) / escandallo;
      }
    },

    calcularPartes(partes, escandallo) {
      if (escandallo === 1) {
        return 0;
      } else if (escandallo === 0) {
        return 0;
      } else {
        return partes % escandallo;
      }
    },
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Steps.name]: Steps,
    [Step.name]: Step,
    [Radio.name]: Radio,
  },
};
</script>

<style scoped>
tbody tr:hover {
  background-color: rgba(0, 153, 130, 0.2);
  cursor: pointer;
}

tbody td {
  padding: 0 !important;
}

td div {
  padding: 12px 8px;
  color: #333;
}

.buttonsSearch:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.1);
}

i {
  font-size: 20px;
}

.card {
  padding: 20px;
}

.input-group button {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Almacen/DetalleSubproductoAlmacen.vue